/**
 * @generated SignedSource<<d2d742f5b815bffc8f5453241a116228>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PatientFileLockFragmentInline$data = {
  readonly id: string;
  readonly inContextOfAppointment: {
    readonly id: string;
  } | null;
  readonly lockRequestedAt: string | null;
  readonly lockRequestedBy: string | null;
  readonly lockedAt: string | null;
  readonly lockedBy: string | null;
  readonly patientId: string;
  readonly requestInContextOfAppointmentId: string | null;
  readonly " $fragmentType": "PatientFileLockFragmentInline";
};
export type PatientFileLockFragmentInline$key = {
  readonly " $data"?: PatientFileLockFragmentInline$data;
  readonly " $fragmentSpreads": FragmentRefs<"PatientFileLockFragmentInline">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "PatientFileLockFragmentInline"
};

(node as any).hash = "5abfe876354d39d9581e44efd9ea3fd6";

export default node;
